module.exports = __webpack_public_path__ + "media/public/fonts/QanelasRegular/QanelasRegular-0037f52e611c2b3bcb7aee9de3a04dcd.woff";